// AES-128-CBC. Key: first 16 bytes of x-api-key. Output: urlencode(Base64(IV + ciphertext))
export default async function encryptFieldJP(plaintext: string) {
  const apiKey = process.env.REACT_APP_API_KEY_BOOKDEMO_JP || "";
  const keyBytes = new TextEncoder().encode(apiKey).slice(0, 16);

  if (keyBytes.length < 16)
    throw new Error("REACT_APP_API_KEY_BOOKDEMO_JP must be at least 16 bytes");

  const iv = crypto.getRandomValues(new Uint8Array(16));
  const key = await crypto.subtle.importKey("raw", keyBytes, "AES-CBC", false, [
    "encrypt",
  ]);
  const ciphertext = new Uint8Array(
    await crypto.subtle.encrypt(
      { name: "AES-CBC", iv },
      key,
      new TextEncoder().encode(plaintext),
    ),
  );

  return encodeURIComponent(btoa(String.fromCharCode(...iv, ...ciphertext)));
}
